import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Row, Form, Typography} from 'antd';
import {Field, reduxForm} from "redux-form";
import moment from "jalali-moment";
import DatePickerField from "../formFields/DatePickerField";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import {CSVLink} from "react-csv";

const columns = [
    {
        title: 'کد درخواست',
        dataIndex: 'order_system_code',
        label: 'کد درخواست',
        key: 'order_system_code',
        width:'8%'
    },
    {
        title: 'تاریخ تحویل نهایی',
        dataIndex: 'complete_date',
        label: 'تاریخ تحویل نهایی',
        key: 'complete_date',
        width:'8%'
    },
    {
        title: 'فاکتور قطعات',
        dataIndex: 'B',
        label: 'فاکتور قطعات',
        key: 'B',
        className: 'price',
        width:'5%'
    },
    {
        title: 'ایاب و ذهاب',
        dataIndex: 'C',
        label: 'ایاب و ذهاب',
        key: 'C',
        className: 'price',
        width:'5%'
    },
    {
        title: 'خدمات تکنسین',
        dataIndex: 'D',
        label: 'خدمات تکنسین',
        key: 'D',
        className: 'price',
        width:'5%'
    },
    {
        title: 'جمع فاکتور',
        dataIndex: 'A',
        label: 'جمع فاکتور',
        key: 'A',
        className: 'price',
        width:'5%'
    },
    {
        title: 'پرداخت به تکنسین از قطعه',
        dataIndex: 'G',
        label: 'پرداخت به تکنسین از قطعه',
        key: 'G',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم شرکت از ایاب و ذهاب',
        dataIndex: 'H',
        label: 'سهم شرکت از ایاب و ذهاب',
        key: 'H',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم تکنسین از ایاب و ذهاب',
        dataIndex: 'Z',
        label: 'سهم تکنسین از ایاب و ذهاب',
        key: 'Z',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم شرکت از قطعات',
        dataIndex: 'K',
        label: 'سهم شرکت از قطعات',
        key: 'K',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم شرکت از خدمات',
        dataIndex: 'L',
        label: 'سهم شرکت از خدمات',
        key: 'L',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم تکنسین از خدمات',
        dataIndex: 'W',
        label: 'سهم تکنسین از خدمات',
        key: 'W',
        className: 'price',
        width:'5%'
    },
    {
        title: 'نقد',
        dataIndex: 'cash',
        label: 'نقد',
        key: 'cash',
        className: 'price',
        width:'5%'
    },
    {
        title: 'کارتخوان',
        dataIndex: 'pos',
        label: 'کارتخوان',
        key: 'pos',
        className: 'price',
        width:'5%'
    },
    {
        title: 'چک',
        dataIndex: 'cheque',
        label: 'چک',
        key: 'cheque',
        className: 'price',
        width:'5%'
    },
    {
        title: 'پرداخت اینترنتی',
        dataIndex: 'ipg_payment',
        label: 'پرداخت اینترنتی',
        key: 'ipg_payment',
        className: 'price',
        width:'5%'
    },
    {
        title: 'سهم شرکت',
        dataIndex: 'sum_company_profit',
        label: 'سهم شرکت',
        key: 'sum_company_profit',
        className: 'price',
        width:'7%'
    },
    {
        title: 'سهم تکنسین',
        dataIndex: 'sum_technician_profit',
        label: 'سهم تکنسین',
        key: 'sum_technician_profit',
        className: 'price',
        width:'7%'
    },
];


class City extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
        }
    }

    componentWillMount() {
        this.props.getAreaList();
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        let current_date = new Date();
        let reach_date;
        let stateName;
        let BTotal = 0;
        let CTotal = 0;
        let DTotal = 0;
        let ATotal = 0;
        let GTotal = 0;
        let HTotal = 0;
        let ZTotal = 0;
        let KTotal = 0;
        let LTotal = 0;
        let WTotal = 0;
        let cashTotal = 0;
        let posTotal = 0;
        let chequeTotal = 0;
        let ipg_paymentTotal = 0;
        let totalSumCompanyProfit = 0;
        let totalSumTechnicianProfit = 0;

        if(list && list) {
            for (let i = 0; i < list.length; i++) {
                reach_date = new Date(list[i].reach_date)
                if(current_date < reach_date) {
                    var difference_in_time = parseInt(reach_date.getTime()) - parseInt(current_date.getTime());
                    var difference_in_days = difference_in_time / (1000 * 3600 * 24);
                }

                if(list[i].order && list[i].order.address.stateId) {
                    this.props.getStateInfo(list[i].order.address.stateId)
                    stateName = this.props.stateInfo
                }

                dataSource.push({
                    order_system_code: list[i].ORDER_SYSTEM_CODE,
                    complete_date : list[i].FINISHED_AT ? moment(list[i].FINISHED_AT).format('jYYYY/jM/jD') : '',
                    B : (list[i].B),
                    C : (list[i].C),
                    D : (list[i].D),
                    A : (list[i].B+list[i].C+list[i].D),
                    G : (list[i].G),
                    H : (list[i].H),
                    Z : (list[i].Z),
                    K : (list[i].K),
                    L : (list[i].L),
                    W : (list[i].W),
                    cash                  : parseInt(list[i].CASH),
                    pos                   : parseInt(list[i].POS),
                    cheque                : parseInt(list[i].CHEQUE),
                    ipg_payment           : parseInt(list[i].IPG_PAYMENT),
                    sum_company_profit    : (list[i].SUM_COMPANY_PROFIT),
                    sum_technician_profit : (list[i].SUM_TECHNICIAN_PROFIT),
                });

                //This data is for Excel
                BTotal += (list[i].B);
                CTotal += (list[i].C);
                DTotal += (list[i].D);
                ATotal += (list[i].B+list[i].C+list[i].D);
                GTotal += (list[i].G);
                HTotal += (list[i].H);
                ZTotal += (list[i].Z);
                KTotal += (list[i].K);
                LTotal += (list[i].L);
                WTotal += (list[i].W);
                cashTotal += parseInt(list[i].CASH);
                posTotal += parseInt(list[i].POS);
                chequeTotal += parseInt(list[i].CHEQUE);
                ipg_paymentTotal += parseInt(list[i].IPG_PAYMENT);
                totalSumCompanyProfit += (list[i].SUM_COMPANY_PROFIT);
                totalSumTechnicianProfit += (list[i].SUM_TECHNICIAN_PROFIT);
            }
            //This column is for Excel
            dataSource.push({
                order_system_code: 'جمع فاکتور',
                complete_date : '',
                technician_settle_time : '',
                B : BTotal,
                C : CTotal,
                D : DTotal,
                A : ATotal,
                G : GTotal,
                H : HTotal,
                Z : ZTotal,
                K : KTotal,
                L : LTotal,
                W : WTotal,
                cash                  : cashTotal,
                pos                   : posTotal,
                cheque                : chequeTotal,
                ipg_payment           : ipg_paymentTotal,
                sum_company_profit    : totalSumCompanyProfit,
                sum_technician_profit : totalSumTechnicianProfit,
            });
        }
        return dataSource;
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList()
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;
        const { Text } = Typography;

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();
        var cityList = [];

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        var data = this.__fixListForShowInTable()
        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">گزارش عملکرد شهرها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length > 0 ?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={columns}
                                    className='export-link'
                                    filename={"report_city.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                            </RTLButton>
                            : null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="state"
                                    component={SelectFieldForLoadState}
                                    placeholder="استان"
                                    list={stateList}
                                    onChangeVal={(stateId) => _self.setState({stateId : stateId})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="city"
                                    component={SelectFieldForLoadCity}
                                    placeholder="شهر"
                                    list={cityList}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } className={'reportTable'}
                              pagination={false} columns={columns}
                              dataSource={this.__fixListForShowInTable()} size="small"
                    />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default City = reduxForm({
    form: 'list'
})(City)
